import classNames from 'classnames';
import { ReactNode } from 'react';
import { ClassName } from 'types/ClassName';
import './badge.scss';

export interface IBadgeProps {
  color?: 'primary' | 'gray' | 'dark-blue';
  className?: ClassName;
  children: ReactNode;
}

const Badge = (props: IBadgeProps) => {
  const { color = 'gray', className, children } = props;

  const classes = classNames(
    {
      badge: true,
      [`badge-${color}`]: true,
    },
    className
  );

  return <div className={classes}>{children}</div>;
};

export default Badge;
